<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/RPZz4x/tc-custom/9781429925716.jpg?1732051005570" alt="This image is the cover for the book Delilah"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Delilah
      </h1>
      <p class="bookDescription body article font2">
        <p>Given to the temple of Atargatis as a child, Delilah is raised to be a priestess to the Five Cities that rule Canaan.  With her beloved friend Aylah, Delilah grows up under the watchful eyes of high priestess Derceto, who sees the devout young priestesses as valuable playing pieces in her political schemes.<br/><br/>In the hills of Canaan, the Israelites chafe under the rule of the Five Cities, and choose Samson to lead them to victory.  A reluctant warrior, Samson is a man of great heart who prefers peace to war.  But fearing a rebellion, those who rule the Five Cities will do anything to capture Samson. When Samson catches a glimpse of Delilah, he is ready to risk his freedom to marry her, and Derceto seizes the chance to have Samson at her mercy. The Temple's intrigues against Samson force Aylah and Delilah apart, lead Delilah to question her own heart, and change her future forever. <br/><br/>A glorious and inventive retelling of an ancient story, <i>Delilah</i> is a soaring tale of political turmoil, searing betrayal, passionate friendship, and forbidden love.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        India Edghill
      </h2>
      
      <p class="authorDescription body article"><P>INDIA EDGHILL is a librarian living in the Mid-Hudson Valley in New York. She is the author of two other novels, <I>Wisdom's Daughter</I>, which was a <I>Romantic Times</I> Nominee for Best Historical Fiction, and <I>Queenmaker</I>.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5fc4e288